import Nullstack from 'nullstack';
export default function IconThreedRotate({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-3d-rotate",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M12 3a7 7 0 0 1 7 7v4l-3 -3"
  }), "   ", Nullstack.element("path", {
    d: "M22 11l-3 3"
  }), "   ", Nullstack.element("path", {
    d: "M8 15.5l-5 -3l5 -3l5 3v5.5l-5 3z"
  }), "   ", Nullstack.element("path", {
    d: "M3 12.5v5.5l5 3"
  }), "   ", Nullstack.element("path", {
    d: "M8 15.545l5 -3.03"
  }), " ");
}